'use strict';

namespace Core {

    class SelectedFlight {
        priceMode:any;
        addingFlight: any;
        flight:any;
        noFlight:boolean;
        detailExpanded:boolean;
        detailOpen:boolean;
        isPackagePrice:boolean;
        oneWayOnly:boolean;
        totalFlightCost:number;
        flightCostPerPerson:number;
        buttonType:string;
        showButton:boolean;
        showChangeFlight:boolean;
        displayAlternative:boolean;
        changeFlightTracking:string;
        trackingPage:string;
        tripId: string;
        skipRedirectionUpgradeFare: boolean;


        constructor (
            private $routeParams,
            private $scope,
            private baggageService,
            private basketService,
            private basketStore,
            private broker,
            private occupancyService,
            private preferences,
            private tripService
        ) {

            if (this.$routeParams.tripId) {
                this._init(this.$routeParams.tripId);
            } else if (this.tripId) {
                this._init(this.tripId);
            } else {
                return;
            }
        }

        private _init(tripId: string) {

            this.preferences.get('priceMode').then(p => {
                this.priceMode = p;
            });

            this.addingFlight = this.basketStore.addingFlight();
            this.noFlight = false;
            this.detailExpanded = false;
            this.buttonType = this.showButton ? 'keep' : 'none';

            this.tripService.usePackageRates(tripId).then(packagePrice => {
                this.detailOpen = TRPCONFIG.Domain.isAgentMode
                    || TRPCONFIG.Domain.FlightDetailsExpanded
                    || TRPCONFIG.Domain.BestFitFlightSelection
                    || packagePrice;
                this.isPackagePrice = packagePrice;
            });

            this.tripService.getTrip(tripId).then(trip => {
                const basketId = trip.BasketId;
                this.basketService.getFlight(basketId).then(flight => {
                    if (flight) {
                        this.flight = flight.Details.Itinerary;
                        this._updateFlightWithTrip(trip);
                        this.flight.DepositAllowed = !_.isEmpty(flight.FuturePayments);
                        this._flightCost(trip);
                        this._hasBaggage(trip, this.flight);
                        this.oneWayOnly = this.flight.Legs.length === 1;
                    } else {
                        this.noFlight = true;
                    }
                });

                //we need to listen out for the flight to be ready here as well as requesting it directly because
                //it might be in the process of being added to the basket
                this.broker.subscribe('SelectedFlight', 'flightAddedToBasket', f => {
                    this.flight = f.data.Details.Itinerary;
                    this.tripService.getTrip(tripId).then(this._updateFlightWithTrip.bind(this));
                    this._flightCost(trip);
                    this._hasBaggage(trip, this.flight);
                });


                this.broker.subscribe('SelectedFlight', 'basketUpdated', _.debounce(()=> {
                    this._flightCost(trip);
                    this._hasBaggage(trip, this.flight);
                }, 100));

                this.broker.subscribe('SelectedFlight', 'priceModeChanged', event => {
                    this.priceMode = event.data;
                });

                this.$scope.$on('$destroy', () => {
                    this.broker.unsubscribe('SelectedFlight');
                });
            });
        }

        keepFlight(params) {
            if (TRPCONFIG.Domain2.IsHotelFirstJourneyEnabled) {
                return this.basketService.changeJourneyUrl(40, this.tripId);
            }
            let opts = {
                bags: this.flight.bags,
                maxbags: this.occupancyService.getNumberOfNonInfantPassengers() || 1,
            };
            return this.basketService.selectFlight(this.flight, this.$routeParams.tripId, opts, this.$routeParams);
        }

        _updateFlightWithTrip(trip) {
            const selectedFlight: Core.Flights.Flight|undefined = _.get(trip, 'FlightsRequest.SelectedFlight');
            if (selectedFlight) {
                this.flight.FlightId = selectedFlight.FlightId;
                this.flight.LeadAdultPrice = selectedFlight.LeadAdultPrice;
                this.flight.LeadAdultTax = selectedFlight.LeadAdultTax;
                this.flight.LeadBaggagePrice = selectedFlight.LeadBaggagePrice;
                this.flight.AllBagsOrNone = selectedFlight.AllBagsOrNone;
                this.flight.PriorityForPreSelection = selectedFlight.PriorityForPreSelection;
            }
        }

        flightImage(fallback) {
            if (!this.flight) {
                return `${fallback} ...`;
            }
            let count = 0;
            let images = '';
            const img = '<img src="/build/img/Airline/Small/{0}" />';
            this.flight.AirlineImages.forEach(function(i) {
                if (count < 3) {
                    images += String.format(img, i);
                    count++;
                }
            });
            return images;
        }

        _flightCost(trip) {
            this.basketStore.flightCost(trip.BasketId).then(c => {
                this.tripService.getTripReducedOccupancy(trip.TripId).then( passengers => {
                    const totalPassengers = _.get(passengers,'Adults',0)
                    || this.occupancyService.getNumberOfNonInfantPassengers();
                    this.totalFlightCost = c;
                    this.flightCostPerPerson = c / totalPassengers;
                    this.addingFlight = false;
                });
            });
        }

        _hasBaggage(trip, flight) {
            if (flight) {
                this.baggageService.getBaggageInfo(trip.TripId).then(function(bagInfo) {
                    flight.Legs.forEach((l, i) => {
                        if (l.BagsIncludedCount > 0) {
                            //this means that the leg already comes with bags
                            //(though we may not have known this at the time we selected the flight
                            l.passengerBagCount = l.BagsIncludedCount;
                        } else {
                            //if the leg does not include baggage, we use the number of bags that
                            //the user has currently selected
                            l.passengerBagCount = bagInfo[i]
                                ? bagInfo[i].holdBagCount
                                : bagInfo[0] && bagInfo[0].holdBagCount || 0;
                        }
                    });
                });
            }
        }

        toggleDetail() {
            this.detailOpen = !this.detailOpen;
        };

        expandDetail() {
            this.detailExpanded = !this.detailExpanded;
        };

        showDetails() {
            this.broker.publish('showModalFlightDetails', { flight: this.flight });
        };
    }

    angular
    .module('TR')
    .directive('selectedFlight', (): ng.IDirective => {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            controller: SelectedFlight,
            controllerAs: 'sf',
            bindToController: {
                expanded: '=',
                showButton: '=',
                showChangeFlight: '=',
                displayAlternative: '=',
                changeFlightTracking: '=',
                trackingPage: '@',
                tripId: '=?',
                skipRedirectionUpgradeFare: '=?',
                showBrandedFareTypes: '=?'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedFlight',
        };
    });

}

